import type { Msg, Session } from '@halo/chat-sdk-react';
import { CardMessage, MessageMetaRoot, OfficialIcon } from '@halo/ui-chat-react';
import { Center } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { useRobotInfo } from '@/components/RobotProfileDialog/Helper';
import {
  MsgAvatar,
  MsgBody,
  MsgForwardFrom,
  MsgHeader,
  MsgItem,
  MsgMenuTrigger,
  MsgFooter,
  MsgFooterEdit,
  MsgFooterReplies,
  MsgBubble,
  MsgReadStatus,
} from '../../msg-parts';

// Message
export interface MsgCardProps {
  session: Session;
  message: Msg;
}

export const MsgCard = memo(function MsgCard({ session, message }: MsgCardProps) {
  const isForwarded = message.msg_ext?.forwardUid;
  const bubbleProps = useMemo(() => (isForwarded ? undefined : { p: '0' }), [isForwarded]);
  const { isofficial } = useRobotInfo(session?.user_info);
  return (
    <MsgItem message={message}>
      <MsgAvatar message={message} session={session} />
      <MsgBody message={message}>
        <MsgHeader
          message={message}
          session={session}
          userNameAfter={isofficial && <OfficialIcon width="1.2em" height="1.2em" />}
        />
        <MsgMenuTrigger message={message}>
          <MsgBubble message={message} {...bubbleProps}>
            {isForwarded && <MsgForwardFrom forwardUid={message.msg_ext.forwardUid} />}
            <CardMessage message={message} />
            <MessageMetaRoot>
              <Emoji.MessageMeta chat_id={session.chat_id} message={message} />
              <Center marginLeft="auto" gap="1.5">
                <MsgReadStatus message={message} session={session} />
              </Center>
            </MessageMetaRoot>
          </MsgBubble>
        </MsgMenuTrigger>
        <MsgFooter message={message}>
          <MsgFooterEdit session={session} message={message} />
          <MsgFooterReplies message={message} />
        </MsgFooter>
      </MsgBody>
    </MsgItem>
  );
});
